/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchAddressResultDto } from '../../models/search-address-result-dto';

export interface SearchForPropertyByAddressPfi$Params {
  addressPfi: number;
}

export function searchForPropertyByAddressPfi(
  http: HttpClient,
  rootUrl: string,
  params: SearchForPropertyByAddressPfi$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchAddressResultDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    searchForPropertyByAddressPfi.PATH,
    'get',
  );
  if (params) {
    rb.path('addressPfi', params.addressPfi, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchAddressResultDto>;
      }),
    );
}

searchForPropertyByAddressPfi.PATH =
  '/search/address/property/address_pfi/{addressPfi}';
